import React from 'react'
import { NavLink } from 'react-router-dom'
import {Container, Row, Col  } from 'react-bootstrap';
export default function BannerBar() {
    return (
        <div className="BannerBar">
            <Container fluid className="bnr-bl-bg">
                <Container>
                    <Row>
                        <Col className="bn-heading"></Col>
                        <Col sm={7} className="bn-heading">Join us and receive online paid surveys</Col>
                        <Col sm={4} className="join-now text-uppercase">
                            <NavLink to="/registration/">Join & Start Earning </NavLink>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </div>
    )
}
